import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ToolbarComponent } from '../toolbar/toolbar.component';

@Component({
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss'],
	imports: [MatIcon, MatIconButton, ToolbarComponent],
})
export class PageNotFoundComponent {
	private router = inject(Router);
	private location = inject(Location);

	goHome() {
		this.router.navigate(['/home']);
	}

	toolbarIconClick() {
		this.location.back();
	}
}
